// Positional index maps for array-of-arrays payloads (spec §4.2). Never use magic numbers.
export const FLOW_IDX = {
  econ: 0,
  hs: 1,
  oldTariff: 2,
  oldTariffCode: 3,
  newTariff: 4,
  newTariffCode: 5,
  currentImportValue: 6,
  tradeLoss: 7,
  elasticity: 8,
  tariffEqual: 9,
  tradeDiversion: 10,
  totalLossGain: 11,
  pctChange: 12,
} as const

export const REPORTER_IDX = {
  hs: 0,
  currentWorldTradeVal: 2,
  tradeLoss: 3,
  tradeDiversion: 4,
  totalCombined: 5,
  pct: 6,
} as const

export const PARTNERS_TABLE_IDX = {
  econ: 0,
  tradeLoss: 1,
  tradeDiversion: 2,
  totalEffect: 3,
  commoditiesAffectedCount: 4,
} as const

export const DIVERTED_TABLE_IDX = {econ: 0, gainAmount: 1} as const

export interface GroupReporter {
  rep: string
  counter: number
  hs_v: string
}

export interface GroupDetail {
  title: string
  economies: string // ';' separated ISO3
  group_reporters?: GroupReporter[]
}

export interface PreferentialTradePartnersResponse {
  bilateral_partners: string[]
  bilateral_details: Record<string, number>
  group_partners: string[]
  group_details: Record<string, GroupDetail>
  data_availability: number[]
}

export interface SimulationParams {
  econ: string
  year: number
  elas_supply: number
  elas_substitution: number
  elas_type: 1 | 2
  price_effect: 0
  exclude_bilateral_agreements: string[]
  exclude_group_agreements: string[]
  combine_effects_diversion: true
}

export interface SimulationMeta {
  counter_trade_flows: number
  counter_calc_trade_creation: number
  counter_data_no_elas_demand: number
  counter_potentially_calculate: number
  calculation_time: number
  [key: string]: number
}

export interface SimulationSummary {
  result_sum_trade_creation: number
  result_sum_trade_diversion: number
  result_sum_trade_effect_total: number
}

export interface SimulationResponse {
  meta: SimulationMeta
  summary: SimulationSummary
  table_data: any[][]
  reporter_affected: any[][]
  partners_affected: {
    trade_creation: Record<string, number>
    trade_diversion: Record<string, number>
    total: Record<string, number>
    partners_table_data: any[][]
    diverted_to_table_data: any[][]
    diverted_to_detail_data: {
      counter: Record<string, [number, number, number]>
      top_flows: Record<string, [string, string, number][]>
      top_partners: Record<string, [string, number][]>
    }
  }
  current_trade: Record<string, number> // mixes 'total_sum' key with per-ISO3 keys
  hs_descriptions: Record<string, string>
}

// 16-column display row for the Affected Trade Flows table (hs_description inserted at index 3)
export type AffectedFlowRow = {
  econ: string
  hs: string
  hsDescription: string
  oldTariff: number
  oldTariffCode: string
  newTariff: number
  newTariffCode: string
  currentImportValue: number
  tradeLoss: number
  elasticity: number
  tariffEqual: number
  tradeDiversion: number
  totalLossGain: number
  pctChange: number
}
